module.exports = __webpack_public_path__ + "img/img11.a4ce57a8.png";